import GetMenuResponse from '../CRM/Responses/MenuResponse';

import Model from './Model';

export default class Menu extends Model {
    readonly id: number;
    readonly name: string;
    readonly slug: string;
    readonly language_id: number;
    readonly translation_id: number;

    constructor(menu: Partial<GetMenuResponse>) {
        super();
        this.assignDataToProps(menu, ['id', 'name', 'slug', 'language_id', 'translation_id']);
    }
}
